import { OwnerTypes } from '@mews-commander/data-access';

export const getOwnerType = (values: string[]): OwnerTypes[] => {
    if (!Array.isArray(values) || values.length === 0) {
        return [];
    }

    const uniqueValues = Array.from(new Set(values));

    if (Array.isArray(values)) {
        return uniqueValues.map((v) => v as OwnerTypes);
    }

    return [OwnerTypes.Unknown];
};
